import ModalAttached from 'app_components/modules/ModalAttached/ModalAttached'
import { default_approval_criteria_files } from 'app_config/globals'
import { CourseSchedulingModes } from 'app_types/admin/courseScheduling/courseSchedulingModeTypes'
import { IMyCourse } from 'app_types/campus/academic/myCoursesTypes'
import React, { FC, useMemo, useState } from 'react'

import './StudentDashboardApprovalCriteria.scss'
import { HiDownload } from 'react-icons/hi'

interface IStudentDashboardApprovalCriteriaProps {
  courseScheduling: IMyCourse
}

const StudentDashboardApprovalCriteria: FC<IStudentDashboardApprovalCriteriaProps> = ({
  courseScheduling,
}) => {
  const [openModal, setOpenModal] = useState<boolean>(false)

  const defaultAttachedId = useMemo(() => {
    const modality = courseScheduling?.schedulingMode?.name
    if (modality === CourseSchedulingModes.VIRTUAL) {
      return default_approval_criteria_files?.virtual
    } else {
      return default_approval_criteria_files?.onSite
    }
  }, [courseScheduling])

  const attachedId = courseScheduling?.approval_criteria ? courseScheduling?.approval_criteria : defaultAttachedId
  if (!attachedId) return null

  return (
    <div className="student-dashboard-approval-criteria--layout">
      <p onClick={() => setOpenModal(true)} style={{ color: 'var(--gray-600)', cursor: 'pointer' }}>
        <HiDownload fontSize="20px" /> &nbsp; &nbsp;
        <span style={{ textDecoration: 'underline' }}>
          Criterios de aprobación
        </span>
      </p>
      <ModalAttached
        open={openModal}
        onClose={() => setOpenModal(false)}
        category="course_scheduling_approval_criteria"
        defaultValue={attachedId}
        disabled
        title='Criterios de aprobación'
      />
    </div>
  )
}

export default StudentDashboardApprovalCriteria
